<div class="icon icon-{{size}}">
  <svg viewBox="0 0 24 24">
    <use [attr.xlink:href]="'#'+name"></use>
  </svg>
</div>
